module.exports = __webpack_public_path__ + "static/15-insights-2-44db7e4cd9cea1ab885f44e1cda8f187.jpg";